// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3w-2t","checkboxCol":"Table_checkboxCol__311jm","emailCol":"Table_emailCol__34yz0","actionCol":"Table_actionCol__1dafo"};